import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useState } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import JournalEntryDialog from './JournalEntryDialog';

const JournalEntry = (props: GridCellProps) => {
  const { dataItem } = props;
  const { isPeriodTableDirty, isCheckbookEditable } = useViewCheckbook();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback((e: any) => {
    e.stopPropagation();
    setOpen(true);
  }, []);

  return (
    <>
      <GridCellBase
        {...props}
        disableToolTip
        className="!text-center !p-0 relative"
        rowSelectionEnabled
      >
        {!dataItem.isDeleted && !dataItem.isNewGlCode && isCheckbookEditable && (
          <PopUp
            content={
              <PopUpContentWrapper
                type="Information"
                contents={['Please save changes to enable.']}
              />
            }
            show={isPeriodTableDirty}
          >
            <Button
              onClick={handleClick}
              color="success"
              size="sm"
              className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-[50%] mx-auto !my-0`}
              disabled={isPeriodTableDirty}
            >
              Add
            </Button>
          </PopUp>
        )}
      </GridCellBase>
      {open && <JournalEntryDialog open={open} setOpen={setOpen} dataItem={dataItem} />}
    </>
  );
};

export default JournalEntry;
